// extracted by mini-css-extract-plugin
export default {"containerBox":"Support_containerBox__IFmBC","wrapper":"Support_wrapper__RT+r9","inputContainer":"Support_inputContainer__20VJy"};